const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const ssoHost = publicConfig.external_address;

exports.Spaces = {
  read: (query, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/spaces/${query}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  },

  update: (query, accessToken, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/spaces/${query}`,
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, payload);
  },
  getFaq: (spaceId, faqType, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/spaces/${spaceId}/faqs/${faqType}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpLib.request(requestParams, (response) => {
      callback(response);
    }, null);
  }
};
